import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import DropdownContext from './DropdownContext';

export default class DropdownClose extends PureComponent {
  static propTypes = {
    children: PropTypes.node
  };

  onClick(closeDropdown, onClick) {
    closeDropdown && closeDropdown();
    onClick && onClick();
  }

  render() {
    const { children } = this.props;
    const { props } = children;
    const { onClick } = props;

    return (
      <DropdownContext.Consumer>
        {(context) =>
          React.cloneElement(children, {
            ...props,
            onClick: () => this.onClick(context.actions.closeDropdown, onClick)
          })
        }
      </DropdownContext.Consumer>
    );
  }
}
